
/**
 * 都道府県
 */
export class Prefectur {
    /** 都道府県ID */
    id = 0
    /** 都道府県CODE (99) */
    code = ""
    /** 都道府県名 */
    name = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Prefectur>) {
        Object.assign(this, init)
    }
}
